import { AxiosResponse } from 'axios';
import configuration from 'config';
import { SolicitudPendiente } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import apiService from './ApiService';

export class SolicitudesPendientesNuevoOnboarding {
  readonly http = apiService;

  private apiUrl = configuration.apiUrl;

  async getPendingRegistrationRequests(filters?: {
    search_param?: string;
    comunidad_id?: number;
    promotor_id?: number;
    pendientes?: boolean;
    acabadas?: boolean;
  }): Promise<SolicitudPendiente[]> {
    const url = `${this.apiUrl}/onboarding/solicitudes-de-registro/`;
    const response: AxiosResponse = await this.http.get(url, {
      params: filters,
      headers: {
        Accept: 'application/json',
      },
    });
    const datos = response.data;
    const result = new SolicitudPendiente().deserializeArray(datos);

    return result;
  }

  async getPendingRegistrationRequestsById(id: string): Promise<SolicitudPendiente> {
    const url = `${this.apiUrl}/onboarding/solicitudes-de-registro/${id}/`;

    const response: AxiosResponse = await this.http.get(url);
    const result = new SolicitudPendiente().deserialize(response.data);
    return result;
  }

  async deleteSolicitud(id: string): Promise<number> {
    const url = `${this.apiUrl}/onboarding/solicitudes-de-registro/${id}/eliminar/`;

    const response: AxiosResponse<{ status: number }> = await this.http.delete(url);

    return response.data.status;
  }

  async finalizarSolicitud(id: string): Promise<number> {
    const url = `${this.apiUrl}/onboarding/solicitudes-de-registro/${id}/acabar/?nocache=${new Date(Date.now())}`;

    const response: AxiosResponse<{ status: number }> = await this.http.post(url);

    return response.data.status;
  }

  async enviarRecordatorio(id: string): Promise<number> {
    const url = `${this.apiUrl}/onboarding/solicitudes-de-registro/${id}/enviar-mensaje-recordatorio/`;
    const response: AxiosResponse<{ status: number }> = await this.http.post(url);

    return response.data.status;
  }

  async getPendingRegistrationCount(): Promise<number> {
    const url = `${this.apiUrl}/onboarding/solicitudes-de-registro/count/`;
    const response: AxiosResponse = await this.http.get(url);

    return response.data.datos.numeroSolicitudesPendientes;
  }
}
const solicitudesPendientesNuevoOnboarding: SolicitudesPendientesNuevoOnboarding =
  new SolicitudesPendientesNuevoOnboarding();

export default solicitudesPendientesNuevoOnboarding;
